import styled from 'styled-components';

export const StandingWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TitleWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  margin: 0px 0px 10px 5px;
  padding: 10px 0;
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TablesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const HeaderTable = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  //background: ${props => props.theme.colors.mainColorDark};
  height: 30px;
`;

export const CupWrapper = styled.div`
  > :last-child {
    border-bottom: none;
  };
`;




// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/StandingWidgetGazzanet/styles.js